import * as PIXI from "pixi.js";

import { Popup } from "@src/core/ui/components/Popup";

export class InfoPopup extends Popup {
  protected title!: string;
  public width!: number;
  public height!: number;

  protected initializeComponents(): void {
    this.title = "Game Rules";
    this.width = 700;
    this.height = 700;

    super.initializeComponents();
  }

  protected initializeContent(): void {
    const intro = new PIXI.Text({
      text: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut sem nunc, aliquet pretium faucibus in, auctor quis lorem. Nam sollicitudin semper nisi, id suscipit magna. Pellentesque et lobortis turpis. Maecenas pharetra ipsum vulputate purus tempus, in pharetra ligula volutpat. Phasellus sed venenatis nibh. Etiam nulla turpis, porta non mollis vitae, dignissim nec velit. Ut eleifend volutpat mattis. `,
      style: {
        fill: "#ffffff",
        fontSize: 30,
        fontWeight: "bold",
        fontFamily: "uiFont",
        wordWrap: true,
        wordWrapWidth: this.contentSizeX,
        align: "center",
      },
    });

    intro.anchor.set(0.5);
    intro.position.set(0.0);

    this.content.addChild(intro);
  }
}
